import { useApiAuthInstance } from '@skeleton/core/assets/apiAuthInstance';
import type { IManualProvider } from '@skeleton/core/types';

interface UseManualAgentMethodsOptions {
  type: 'deposit' | 'withdrawal';
}

interface IManualProviderInfo {
  accountNumber: string;
  agentId: string;
  id: number;
  cocalCurrency: string;
  maximum: number;
  minimal: number;
  name: string;
}

export const useManualAgentMethods = (options: UseManualAgentMethodsOptions) => {
  const { type } = options;

  const { selectedCurrency } = storeToRefs(useTransactionStore());

  const isLoadingProviders = ref(false);
  const isLoadingProviderInfo = ref(false);
  const providers = ref<IManualProvider[]>([]);
  const providerInfo = ref<IManualProviderInfo | null>(null);
  const currentProvider = ref<IManualProvider | null>(null);

  // Получение списка провайдеров
  const getProviders = async (currency?: string): Promise<void> => {
    try {
      isLoadingProviders.value = true;
      const res = await useApiAuthInstance(
        `/api/payment/manual-agents/${type}-providers?currency=${currency || selectedCurrency.value}`
      );

      providers.value = res?.data || [];
    } catch (error) {
      providers.value = [];
      console.error(`Error getting ${type} providers:`, error);
    } finally {
      isLoadingProviders.value = false;
    }
  };

  const getProviderInfo = async (): Promise<void> => {
    try {
      isLoadingProviderInfo.value = true;

      const provider = providers.value.find(item => item.name === currentProvider.value?.name);

      if (!provider) {
        console.error('Provider not found in providers list');
        providerInfo.value = null;
        return;
      }

      const res = await useApiAuthInstance(`/api/payment/manual-agents/get-provider-info?provider_id=${provider.id}`);

      providerInfo.value = res?.data;
    } catch (error) {
      console.error('Error getting provider info:', error);
      providerInfo.value = null;
    } finally {
      isLoadingProviderInfo.value = false;
    }
  };

  return {
    providers,
    providerInfo,
    currentProvider,
    isLoadingProviders,
    isLoadingProviderInfo,

    getProviders,
    getProviderInfo,
  };
};
